import React, { useState } from 'react';
import { Input } from 'antd';
import { ArrowUp } from 'lucide-react';
import { useLiquidGlass } from '@/hooks';
import { FORM_GLASS_SETTINGS } from '@/constants';
import styles from './SessionInputBar.module.scss';

const { TextArea } = Input;

interface SessionInputBarProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  placeholder: string;
  disabled?: boolean;
  sendDisabled?: boolean;
  maxRows?: number;
  maxLength?: number;
}

export const SessionInputBar: React.FC<SessionInputBarProps> = ({
  value,
  onChange,
  onSend,
  placeholder,
  disabled = false,
  sendDisabled = false,
  maxRows = 5,
  maxLength,
}) => {
  const [focused, setFocused] = useState(false);
  const glassRef = useLiquidGlass<HTMLDivElement>(FORM_GLASS_SETTINGS);

  const canSend = !disabled && !sendDisabled && value.trim().length > 0;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (canSend) onSend();
    }
  };

  return (
    <div ref={glassRef} className={`${styles.bar} ${focused ? styles.focused : ''}`}>
      <TextArea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        placeholder={placeholder}
        disabled={disabled}
        autoSize={{ minRows: 1, maxRows }}
        maxLength={maxLength}
        className={styles.textarea}
      />
      <button
        type="button"
        className={styles.sendBtn}
        onClick={onSend}
        disabled={!canSend}
        aria-label="Send"
      >
        <ArrowUp style={{ width: '1em', height: '1em' }} />
      </button>
    </div>
  );
};
